export default __webpack_public_path__ + "static/media/christtheking.898bc60e.jpg";